import { render, staticRenderFns } from "./airdropSaleRecord.vue?vue&type=template&id=667d51fe&scoped=true"
import script from "./airdropSaleRecord.vue?vue&type=script&lang=js"
export * from "./airdropSaleRecord.vue?vue&type=script&lang=js"
import style0 from "./airdropSaleRecord.vue?vue&type=style&index=0&id=667d51fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d51fe",
  null
  
)

export default component.exports